export const QA = [
    {
        id: 1,
        question: "What are immigration preparers or consultants?",
        answer: "Immigration Preparers or Consultants assist with the preparation and submission of immigration applications and ensure all required forms and documents are correctly completed. Please note that we are not immigration lawyers and cannot provide legal advice.",
    },
    {
        id: 2,
        question: "How much do your services cost?",
        answer: "Our services start at $100. During your consultation, we will discuss the cost in detail based on your specific needs and the complexity of your application.",
    },
    {
        id: 3,
        question: "Do you offer payment plans?",
        answer: "Yes, payment plans are available. Please ask during your consultation.",
    },
    {
        id: 4,
        question: "Do I need an immigration lawyer?",
        answer: "While our services are comprehensive, an immigration lawyer may be necessary for complex legal issues. We can discuss this during your consultation to determine the best approach for your situation.",
    },
]